<script>
import appConfig from "@/app.config";
import Layout from "@/layouts/main.vue";
import CharacterStory from "@/components/characterSlider/CharacterStory.vue";
// import GamesSwiper from "@/components/GamesSwiper.vue";
// import Testimonials from "@/components/testimonials/Testimonials.vue";
// import Recommendation from "@/components/recommendation/Recommendation.vue";
import HelpSupport from "@/components/HelpSupport.vue";

export default {
  page: {
    title: "Characters",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    CharacterStory,
    // GamesSwiper,
    // Testimonials,
    // Recommendation,
    HelpSupport,
  },
  data() {
    return {
      assetsPath: appConfig.assetsPath,
      showLoadingScreen: true,
      charactersHeroStyle: {
        backgroundImage: "url("+appConfig.assetsPath+"images/panda-foot-pattern@2x.png)"
      }
    }
  },
  methods:  {
    scrollToTop() {
      setTimeout(() => {
        window.scrollTo(0,0);   
      }, 300)
    }
  },
  mounted() {
    this.scrollToTop();
    document.onreadystatechange = () => { 
      if (document.readyState == "complete") { 
          this.scrollToTop();
          this.showLoadingScreen = false;
      } 
    }
  },
};
</script>

<template>
  <Layout headerStyle="headerDark" :showLoadingScreen="showLoadingScreen">
    <div :class="$style.charactersHero" class=" d-inline-block w-100 d-flex"
      :style="charactersHeroStyle"
    >
      <b-container>
        <div
          :class="$style.heroContent"
          class="d-flex flex-column justify-content-center align-items-center"
        >
          <h2>{{ $t("characters.sayHi")}}</h2>
          <h1>{{ $t("characters.drPanda")}}</h1>
          <h2>{{ $t("characters.friends")}}</h2>
        </div>
      </b-container>
      <img
        :src="assetsPath + 'images/character-1.svg'"
        alt=""
        :class="[$style.character1, $style.characterImg]"
      />
      <img
        :src="assetsPath + 'images/character-2.svg'"
        alt=""
        :class="[$style.character2, $style.characterImg]"
      />
      <img
        :src="assetsPath + 'images/character-3.svg'"
        alt=""
        :class="[$style.character3, $style.characterImg]"
      />
      <img
        :src="assetsPath + 'images/character-4.svg'"
        alt=""
        :class="[$style.character4, $style.characterImg]"
      />
      <img
        :src="assetsPath + 'images/character-5.svg'"
        alt=""
        :class="[$style.character5, $style.characterImg]"
      />
      <img
        :src="assetsPath + 'images/character-6.svg'"
        alt=""
        :class="[$style.character6, $style.characterImg]"
      />
      <img
        :src="assetsPath + 'images/character-7.svg'"
        alt=""
        :class="[$style.character7, $style.characterImg]"
      />
      <img
        :src="assetsPath + 'images/character-8.svg'"
        alt=""
        :class="[$style.character8, $style.characterImg]"
      />
    </div>
    <div class="w-100 d-inline-block d-flex">
      <CharacterStory :showLoadingScreen="showLoadingScreen" />
    </div>
    <div class="w-100 d-inline-block d-flex pb-5">
      <HelpSupport />
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import "@/design/_colors.scss";
@import "@/design/_fonts.scss";

.charactersHero {
  height: 100vh;
  padding: 120px 0 0;
  background-color: $bg-light-skye-blue;  
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
  overflow: hidden;
  .characterImg {
    position: absolute;
  }
  .character2 {
    top: 15%;
    left: -146px;
  }
  .character1 {
    bottom: 15%;
    left: -83px;
  }
  .character3 {
    left: 15%;
    bottom: -98px;
  }
  .character4 {
    right: 15%;
    bottom: -138px;
  }
  .character5 {
    top: 0%;
    right: -106px;
  }
  .character6 {
    bottom: 0;
    top: 32px;
    right: -166px;
    margin: auto;
  }
  .character7 {
    bottom: 0%;
    right: -126px;
  }
  .character8 {
    left: 30%;
    top: -93px;
  }
}
.heroContent {
  height: calc(720px - 120px);
  padding-bottom: 160px;
  h1 {
    font-size: 72px;
    margin: 10px 0;
    line-height: 1;
  }
  h2 {
    margin: 0;
    font-size: 48px;
  }
}

@media only screen and (max-width: 767px) {
  .charactersHero{
    height: 100vh;
    .character2 {
      top: 15%;
      left: -146px;
    }
    .character1 {
      bottom: 35%;
      left: -103px;
    }
    .character3 {
      left: -130px;
      bottom: -95px;
    }
    .character4 {
      right: 15%;
      bottom: -158px;
    }
    .character5 {
      top: 7%;
      right: -136px;
    }
    .character6 {
      right: -176px;
    }
    .character7 {
      bottom: 11%;
      right: -160px;
    }
    .character8 {
      left: 30%;
      top: -93px;
    }
    .heroContent{
      height: 100%;
      margin-top: -80px;
      padding-bottom: 0;
      h1 {
        font-size: 48px;
        position: relative;
        z-index: 1;
      }
      h2 {
        font-size: 28px;
        position: relative;
        z-index: 1;
      }      
    }
  }

}
@media only screen and (max-height: 600px) {
  .charactersHero {
    .character2 {
      top: 12%;
      left: -76px;
      width: 150px;
    }
    .character1 {
      bottom: 35%;
      left: -71px;
      width: 120px;
    }
    .character3 {
      left: -50px;
      bottom: -45px;
      width: 140px;
    }
    .character4 {
      right: 15%;
      bottom: -98px;
      width: 120px;
    }
    .character5 {
      top: 11%;
      right: -64px;
      width: 120px;
    }
    .character6 {
      right: -81px;
      width: 124px;
    }
    .character7 {
      bottom: 11%;
      right: -68px;
      width: 150px;
    }
    .character8 {
      left: 30%;
      top: -84px;
      width: 90px;
    }
  }  
}
</style>
